// Dependencies
import React, { Component } from 'react';
import RegistrationFormStepTitleComponent from '../form-step-title/form-step-title';

// Primereact imports
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './step-1.scss';

// Redux
import { connect } from 'react-redux';
import { updateFormStep, updateStep1State } from '../../../redux/actions/form';

// Utils
import { getFormValue } from '../../../common/utils/form-utils';
import { FORM_FIELD_AGREEMENT_1, FORM_FIELD_AGREEMENT_2, FORM_FIELD_AGREEMENT_3, FORM_FIELD_AGREEMENT_4, FORM_STEP_1_STATE, REGISTRATION_STATE_REVISION, STEP_STATE_SUBMITTED, STEP_STATE_VALIDATION_ERROR } from '../../../common/constants';

class RegistrationFormStep1Component extends Component {

    constructor(props) {
        super(props);
        this.state = {
            agreement1: { key: FORM_FIELD_AGREEMENT_1, value: false },
            agreement2: { key: FORM_FIELD_AGREEMENT_2, value: false },
            agreement3: { key: FORM_FIELD_AGREEMENT_3, value: false },
            agreement4: { key: FORM_FIELD_AGREEMENT_4, value: false },
            validAgreement: true
        }
    }

    componentDidMount() {
        /*this.setState({
            agreement1: getFormValue(FORM_FIELD_AGREEMENT_1, this.props.formFields),
            agreement2: getFormValue(FORM_FIELD_AGREEMENT_2, this.props.formFields),
            agreement3: getFormValue(FORM_FIELD_AGREEMENT_3, this.props.formFields),
            agreement4: getFormValue(FORM_FIELD_AGREEMENT_4, this.props.formFields)
        })*/
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: { key: column, value: value }
        });
    }

    validateForm() {
        const validAgreement = (this.state.agreement1.value && 
                                this.state.agreement2.value && 
                                this.state.agreement3.value && 
                                this.state.agreement4.value
                               );

        this.setState({
            validAgreement: validAgreement
        });

        return validAgreement;
    }

    submitStep() {
        if(this.validateForm()) {

            this.props.updateStep1State(STEP_STATE_SUBMITTED);

            this.props.updateFormStep(1, 
            [
                { key: FORM_FIELD_AGREEMENT_1, value: this.state.agreement1 },
                { key: FORM_FIELD_AGREEMENT_2, value: this.state.agreement2 },
                { key: FORM_FIELD_AGREEMENT_3, value: this.state.agreement3 },
                { key: FORM_FIELD_AGREEMENT_4, value: this.state.agreement4 },
                { key: FORM_STEP_1_STATE, value: STEP_STATE_SUBMITTED }
            ],
            () => this.props.onNext());
        }
        else {
            this.props.updateStep1State(STEP_STATE_VALIDATION_ERROR);

            this.props.updateFormStep(1, 
                [
                    { key: FORM_STEP_1_STATE, value: STEP_STATE_VALIDATION_ERROR }
                ],
                () => {});
        }
    }

    render() {
        return (
                <>
                    <div id="data-container" className="card p-fluid mgt-20">
                        <div className="grid">
                            <div className="col-12">
                                <div className="grid mgt-10">
                                    <RegistrationFormStepTitleComponent title={this.props.t("registration-form.step-1.title")}
                                                                        subtitles={[
                                                                            this.props.t("registration-form.step-1.subtitle-1"),
                                                                            this.props.t("registration-form.step-1.subtitle-2")
                                                                        ]} />
                                    <div className="col-12 t-align-left mgt-20">
                                        <br/>
                                        <b style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.documentation")}</b>
                                        <ul>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-1")}</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-2")}</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-3")} <a href="https://registocriminal.justica.gov.pt" target="_blank">{this.props.t("general.click-here")}</a>;</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-4")}</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-5")}</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-6")}</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-7")}</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-8")}</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-9")}</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-10")}</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-11")}</li>
                                            <li style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.guide-12")}</li>
                                        </ul>
                                        <br/>
                                        <p style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.privacy-1")} <a href="https://ordemdosfisioterapeutas.pt/politica-de-privacidade/" target="_blank">{this.props.t("general.click-here")}</a> {this.props.t("registration-form.step-1.privacy-2")} <a href="https://ordemdosfisioterapeutas.pt/o-que-sao-cookies" target="_blank">{this.props.t("general.click-here")}</a>.</p>
                                    </div>
                                    <div className="col-12 t-align-left">
                                        <Checkbox inputId="cb-agreement-1" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} checked={this.state.agreement1.value} onChange={e => this.updateFormComponent("agreement1", e.checked)}></Checkbox>
                                        <label htmlFor="cb-agreement-1" className="mgt-5 ml-2" style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.agreement-1-1")} <a href="https://ordemdosfisioterapeutas.pt/politica-de-privacidade/" target="_blank">{this.props.t("registration-form.step-1.agreement-1-2")}</a> {this.props.t("registration-form.step-1.agreement-1-3")} <a href="https://ordemdosfisioterapeutas.pt/o-que-sao-cookies" target="_blank">{this.props.t("registration-form.step-1.agreement-1-4")}</a>.</label>
                                    </div>
                                    <div className="col-12 t-align-left">
                                        <Checkbox inputId="cb-agreement-2" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} checked={this.state.agreement2.value} onChange={e => this.updateFormComponent("agreement2", e.checked)}></Checkbox>
                                        <label htmlFor="cb-agreement-2" className="mgt-5 ml-2" style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.agreement-2")}</label>
                                    </div>
                                    <div className="col-12 t-align-left">
                                        <Checkbox inputId="cb-agreement-3" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} checked={this.state.agreement3.value} onChange={e => this.updateFormComponent("agreement3", e.checked)}></Checkbox>
                                        <label htmlFor="cb-agreement-3" className="mgt-5 ml-2" style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.agreement-3-1")} <a href="https://ordemdosfisioterapeutas.pt/wp-content/uploads/2021/04/3592021.pdf" target="_blank">{this.props.t("registration-form.step-1.agreement-3-2")}</a></label>
                                    </div>
                                    <div className="col-12 t-align-left">
                                        <Checkbox inputId="cb-agreement-4" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} checked={this.state.agreement4.value} onChange={e => this.updateFormComponent("agreement4", e.checked)}></Checkbox>
                                        <label htmlFor="cb-agreement-4" className="mgt-5 ml-2" style={{fontSize: "14px"}}>{this.props.t("registration-form.step-1.agreement-4")}</label>
                                        { !this.state.validAgreement ? <div className="col-12 lg:col-12"><small className="p-error">{this.props.t("registration-form.step-1.valid-agreement")}</small></div> : null }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION ?
                            <div className="mgt-20">
                                <div className="grid">
                                    <div className="col-12 t-align-right mgt-10">
                                        <Button icon="pi pi-question-circle" severity='success' label="Verificar passo 1" raised onClick={(evt) => this.submitStep()} />
                                    </div> 
                                </div>
                            </div>
                            : null
                    }
                </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        registrationState: state.authentication.registrationState,
        formFields: state.form.formFields
    } 
  };
  
const mapDispatchToProps = (dispatch) => {
    return {
        updateFormStep: (stepFields) => { dispatch(updateFormStep(stepFields)) },
        updateStep1State: (state) => { dispatch(updateStep1State(state)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(RegistrationFormStep1Component));